import type { ReactNode } from 'react';
import './EmptyState.css';

type EmptyStateProps = {
    icon?: ReactNode;
    title: string;
    description?: string;
    action?: ReactNode;
};

function EmptyState({ icon, title, description, action }: EmptyStateProps) {
    return (
        <div className="ui-empty" role="status" aria-live="polite">
            {icon && <div className="ui-empty__icon" aria-hidden="true">{icon}</div>}
            <h3 className="ui-empty__title">{title}</h3>
            {description && <p className="ui-empty__desc">{description}</p>}
            {action && <div className="ui-empty__action">{action}</div>}
        </div>
    );
}

export default EmptyState;
